(() => {
    'use strict';

    real.events.on('transformer:prompt:capacity-check:completed', notification => {
        const widget = $('#widget-' + notification.object.widget.id);
        if (widget.length === 0) {
            // No widget found from the DOM.
            return;
        }
        // If the check UID does not match the current one, ignore the result.
        if (widget.data('capacity-check-uid') !== notification.object.widget.check_uid) {
            return;
        }
        widget.dataAndAttr('capacity-check-in-progress', false);

        const startButton = widget.find('.refresh-result-btn');
        real.button.reset(startButton, widget);
        const progress = widget.find('.prompt-context-capacity-use-progress-bar');
        progress.find('.howspace-progress-bar').removeClass('howspace-progress-bar-striped-animated');
        howspace.components.progress.update(progress, notification.object.widget.capacity_use);
        widget.dataAndAttr('transformer-ephemeral-source-size-tokens', notification.object.widget.prompt_tokens);
        // If the capacity is not exceeded, enable the start button.
        const warning = widget.find('.prompt-context-capacity-exceeded-warning');
        if (notification.object.widget.capacity_use < 100) {
            widget.dataAndAttr('capacity-exceeded', false);
            if (!warning.hasClass('d-none')) {
                howspace.animate(warning, 'slideUp', 'fast', () => {
                    warning.addClass('d-none');
                });
            }
        } else if (warning.hasClass('d-none')) {
            widget.dataAndAttr('capacity-exceeded', true);
            howspace.animate(warning, 'slideDown', 'fast', () => {
                warning.removeClass('d-none');
            });
        }
        updateButtonStates(widget);
    });

    real.events.on('transformer:prompt:sources:completed', (notification) => {
        const widget = $('#widget-' + notification.object.widget.id);
        howspace.aiGen.clearPromptTimeout(widget);

        const btn = widget.find('.refresh-result-btn');
        const promptResultContainer = widget.find('.prompt-result');
        const oldResult = widget.find('.prompt-result-content');

        // The new result no longer holds the deleted transcript.
        const sourceDeletedWarning = widget.find('.prompt-result-source-deleted-warning:not(.d-none)');
        if (sourceDeletedWarning.length > 0) {
            howspace.animate(sourceDeletedWarning, 'slideUp', 'fast', () => {
                sourceDeletedWarning.addClass('d-none');
            });
        }

        if (widget.data('widget-mode') === 'edit') {
            const progress = widget.find('.prompt-context-capacity-use-progress-bar');
            howspace.components.progress.update(progress, notification.object.widget.capacity_use);

            $('.real-notification-bar').hide();
            // Store the transformer result to the widget data attribute for possible saving.
            widget.dataAndAttr('transformer-ephemeral-result', notification.object.widget.result);
            widget.dataAndAttr('transformer-ephemeral-source-size-tokens', notification.object.widget.prompt_tokens);
            promptResultContainer.dataAndAttr('source-widgets-for-result', getSourceWidgetsForResult(widget));
            const userPromptTextarea = widget.find('.user-prompt-textarea');
            userPromptTextarea.data('user-prompt-for-result', userPromptTextarea.val());
            // Hide the stale prompt result warning.
            const staleResultWarning = widget.find('.prompt-result-warning');
            if (!staleResultWarning.hasClass('d-none')) {
                howspace.animate(staleResultWarning, 'slideUp', 'fast', () => {
                    staleResultWarning.addClass('d-none');
                });
            }
            updateButtonStates(widget);
        } else {
            real.button.reset(widget.find('.prompt-actions-wrapper .btn'), widget.find('.prompt-actions-wrapper'));
        }

        // Clone the old result, update its HTML, hide it and append to the promptResultContainer.
        let newResult = oldResult.clone();
        newResult.html(notification.object.widget.result_html);
        newResult.hide();
        promptResultContainer.append(newResult);

        real.animator()
            .setParentElement(promptResultContainer)
            .setHideElement(oldResult)
            .setShowElement(newResult)
            .setAnimDuration(700)
            .onHideReady(() => {
                oldResult.remove();
            })
            .onShowReady(() => {
                real.button.reset(btn);
                newResult.removeClass('translated');
                howspace.components.init(promptResultContainer);
            }).startAnimation();
    });

    real.events.on('transformer:prompt:sources:failed', (notification) => {
        const widget = $('#widget-' + notification.object.widget.id);
        const startButton = widget.find('.refresh-result-btn');
        const progress = widget.find('.prompt-context-capacity-use-progress-bar');

        const timeoutId = widget.data('prompt-timeout-timer-id');
        if (timeoutId) {
            clearTimeout(timeoutId);
            widget.dataAndAttr('prompt-timeout-timer-id', null);
        }

        howspace.components.progress.update(progress, 100);
        const promptResultContainer = widget.find('.prompt-result');
        howspace.animate(promptResultContainer, 'slideUp', 350, () => {
            promptResultContainer.find('.prompt-result-content').html('');
            howspace.animate(promptResultContainer, 'slideDown', 350);
            real.button.reset(startButton, widget);
        });
        if (notification.object.error) {
            real.notification.show(notification.object.error, 'danger');
        } else {
            real.notification.show(howspace.translate('transformer_prompt_failed'), 'danger');
        }

    });

    const getSourceWidgetsAsPayload = widget => {
        const sourceWidgets = [];
        widget.find('.howspace-item-picker .selected-items .item').each((index, element) => {
            const widgetType = element.getAttribute('data-type');
            let widgetId = element.getAttribute('data-id');
            widgetId = widgetId.replace(widgetType + '-', '');
            sourceWidgets.push({type: widgetType, id: widgetId});
        });
        return sourceWidgets;
    };

    const getSourceWidgetsForResult = widget => {
        const sourceWidgets = [];
        getSourceWidgetsAsPayload(widget).forEach((item) => {
            sourceWidgets.push(item.type + ':' + item.id);
        });
        return sourceWidgets;
    };

    const initTransformer = (startButton, widget) => {
        updateButtonStates(widget);
        startButton.on('click', () => {
            real.button.loading(startButton);
            updateButtonStates(widget)

            const dataPayload = {
                sources: getSourceWidgetsAsPayload(widget),
                user_prompt: widget.find('textarea[name="user_prompt"]').val()
            };
            const promptTokens = widget.data('transformer-ephemeral-source-size-tokens');
            if (promptTokens) {
                dataPayload.sources_size_tokens = promptTokens;
            }

            widget.find('.prompt-result-warning').addClass('d-none');

            const promptResultContainer = widget.find('.prompt-result');
            const oldResult = widget.find('.prompt-result-content');
            const newResult = oldResult.clone();
            newResult.html('<div class="howspace-loader medium"></div>');
            newResult.hide();
            promptResultContainer.append(newResult);
            real.animator()
                .setParentElement(promptResultContainer)
                .setHideElement(oldResult)
                .setShowElement(newResult)
                .setAnimDuration(700)
                .onHideReady(() => {
                    oldResult.remove();
                })
                .startAnimation();

            const showTimeoutMessageAsResult = () => {
                howspace.animate(promptResultContainer, 'slideUp', 350, () => {
                    promptResultContainer.find('.prompt-result-content').html('<div class="alert alert-danger">' + howspace.translate('transformer_prompt_timeout') + '</div>');
                    howspace.animate(promptResultContainer, 'slideDown', 350);
                    real.button.reset(startButton, widget);
                });
            };

            // Set a timeout for 60 seconds
            const timeoutId = setTimeout(() => {
                if (widget.data('prompt-timeout-timer-id') === timeoutId) {
                    showTimeoutMessageAsResult();
                }
            }, 60000); // 60 seconds

            // Clear any existing timeout
            const existingTimeoutId = widget.data('prompt-timeout-timer-id');
            if (existingTimeoutId) {
                clearTimeout(existingTimeoutId);
            }

            // Store the new timeout ID
            widget.dataAndAttr('prompt-timeout-timer-id', timeoutId);

            // Trigger the transformer work start
            real.ajax.json(real.baseUri + '/api/ai/transformer/start/' + widget.data('widget-id'), {
                type: 'POST',
                data: JSON.stringify(dataPayload),
                error: (response) => {
                    clearTimeout(timeoutId); // Clear the timeout on error
                    if (response.status === 429) {
                        // Restore the last prompt result.
                        showTimeoutMessageAsResult();
                    } else {
                        real.notification.show(howspace.translate('transformer_start_failed'), 'danger');
                    }
                }
            });
        });
    };

    function checkCapacity(widget) {
        const checkUid = real.uid();
        widget.dataAndAttr('capacity-check-uid', checkUid);
        const progressBar = widget.find('.prompt-context-capacity-use-progress-bar .howspace-progress-bar');
        progressBar.addClass('howspace-progress-bar-striped-animated');

        const dataPayload = {
            sources: getSourceWidgetsAsPayload(widget), check_uid: checkUid,
            user_prompt: widget.find('textarea[name="user_prompt"]').val()
        }
        real.ajax.json(real.baseUri + '/api/ai/transformer/check-data-size/' + widget.data('widget-id'), {
            type: 'POST', data: JSON.stringify(dataPayload), success: () => {
                // Nothing to do.
            }, error: () => {
                updateButtonStates(widget)
                real.notification.show(howspace.translate('transformer_check_prompt_data_size_failed'), 'danger');
            }
        });
    }

    function updateButtonStates(widget) {
        const currentSourceWidgets = getSourceWidgetsForResult(widget).sort();
        if (
            currentSourceWidgets.length === 0 ||
            widget.data('capacity-check-in-progress') ||
            widget.data('capacity-exceeded')
        ) {
            // No source widgets selected, capacity check in progress or capacity exceeded. Disable both buttons.
            widget.find('.save-widget-btn').prop('disabled', true);
            widget.find('.refresh-result-btn').prop('disabled', true);
            return;
        }

        // Enable the refresh result button.
        widget.find('.refresh-result-btn').prop('disabled', false);

        const sourceWidgetsForResult = widget.find('.prompt-result').data('source-widgets-for-result').sort();
        const userPromptTextarea = widget.find('.user-prompt-textarea');
        const promptResult = widget.find('.prompt-result-content').html().trim();
        if (
            JSON.stringify(currentSourceWidgets) !== JSON.stringify(sourceWidgetsForResult) ||
            userPromptTextarea.val() !== userPromptTextarea.data('user-prompt-for-result') ||
            promptResult.length === 0
        ) {
            // Source widgets or user prompt has changed since last result (if any) or no prompt result available. Disable save button.
            widget.find('.save-widget-btn').prop('disabled', true);
            return;
        }

        // All good, enable also the save button.
        widget.find('.save-widget-btn').prop('disabled', false);
    }

    howspace.widgets.transformer = {
        initView: widget => {

            widget.find('.refresh-result-btn').on('click', e => {
                const startBtn = $(e.target);
                real.button.loading(startBtn);
                real.button.loading(widget.find('.prompt-actions-wrapper .button'), widget.find('.prompt-actions-wrapper'));

                const promptResultContainer = widget.find('.prompt-result');
                const oldResult = widget.find('.prompt-result-content');
                const newResult = oldResult.clone();
                newResult.html('<div class="howspace-loader medium"></div>');
                newResult.hide();
                promptResultContainer.append(newResult);
                real.animator()
                    .setParentElement(promptResultContainer)
                    .setHideElement(oldResult)
                    .setShowElement(newResult)
                    .setAnimDuration(700)
                    .onHideReady(() => {
                        oldResult.remove();
                    })
                    .startAnimation();

                // Set a timeout for 60 seconds
                const timeoutId = setTimeout(() => {
                    if (widget.data('prompt-timeout-timer-id') === timeoutId) {
                        real.button.reset(startBtn, widget);
                        widget.find('.prompt-result-content').html('<div class="alert alert-danger">' + howspace.translate('transformer_prompt_timeout') + '</div>');
                    }
                }, 60000); // 60 seconds

                // Clear any existing timeout
                const existingTimeoutId = widget.data('prompt-timeout-timer-id');
                if (existingTimeoutId) {
                    clearTimeout(existingTimeoutId);
                }

                // Store the new timeout ID
                widget.dataAndAttr('prompt-timeout-timer-id', timeoutId);

                // Trigger the transformer work start
                real.ajax.json(real.baseUri + '/api/ai/transformer/start/' + widget.data('widget-id'), {
                    type: 'GET',
                    // The result only arrives over the websocket.
                    waitForWebsocket: true,
                    error: () => {
                        clearTimeout(timeoutId); // Clear the timeout on error
                        real.notification.show(howspace.translate('transformer_start_failed'), 'danger');
                        real.button.reset(startBtn);
                    }
                });
            });

            widget.find('.generate-poll-btn').on('click', (e) => {
                howspace.aiGen.promptGenerateWidget($(e.target), widget, 'poll', widget.find('.prompt-result .result-content').html());
            });

            widget.find('.generate-pulse-btn').on('click', (e) => {
                howspace.aiGen.promptGenerateWidget($(e.target), widget, 'pulse', widget.find('.prompt-result .result-content').html());
            });

            widget.find('.generate-priority-btn').on('click', (e) => {
                howspace.aiGen.promptGenerateWidget($(e.target), widget, 'priority', widget.find('.prompt-result .result-content').html());
            });

            widget.find('.generate-allocate-btn').on('click', (e) => {
                howspace.aiGen.promptGenerateWidget($(e.target), widget, 'allocate', widget.find('.prompt-result .result-content').html());
            });

        }, destroyView: widget => {
            // Empty for now.
        }, initEdit: widget => {
            const sourcePicker = widget.find('.howspace-item-picker');

            const showStaleResultsWarning = () => {
                const staleResultWarning = widget.find('.prompt-result-warning');
                if (staleResultWarning.hasClass('d-none')) {
                    howspace.animate(staleResultWarning, 'slideDown', 'fast', () => {
                        staleResultWarning.removeClass('d-none');
                    });
                }
            }

            const triggerCapacityCheck = () => {
                // Disable the buttons.
                widget.dataAndAttr('capacity-check-in-progress', true);
                updateButtonStates(widget);

                // Clear the previous timeout.
                if (widget.data('capacity-check-timeout-id') !== null) {
                    clearTimeout(widget.data('capacity-check-timeout-id'));
                }

                // Set a new timeout to 1,5 seconds.
                widget.data('capacity-check-timeout-id', setTimeout(() => {
                    checkCapacity(widget);
                }, 1500));
            };

            sourcePicker.on(howspace.components.itemPicker.ITEM_ADDED, () => {
                showStaleResultsWarning();
                triggerCapacityCheck();
            });

            sourcePicker.on(howspace.components.itemPicker.ITEM_REMOVED, () => {
                showStaleResultsWarning();
                triggerCapacityCheck();
            });

            widget.find('textarea[name="user_prompt"]').on('input', () => {
                showStaleResultsWarning();
                updateButtonStates(widget);
            });

            const startButton = widget.find('.refresh-result-btn');
            initTransformer(startButton, widget);
        }, destroyEdit: widget => {
            const promptTimeoutId = widget.data('prompt-timeout-timer-id');
            if (promptTimeoutId) {
                clearTimeout(promptTimeoutId);
                widget.removeDataAndAttr('prompt-timeout-timer-id');
            }
            const capacityCheckTimeoutId = widget.data('capacity-check-timeout-id');
            if (capacityCheckTimeoutId) {
                clearTimeout(capacityCheckTimeoutId);
                widget.removeDataAndAttr('capacity-check-timeout-id');
            }
        }, save: (widget, dataPayload) => {
            // Transformer expects sources, not items.
            dataPayload.sources = getSourceWidgetsAsPayload(widget);
            delete dataPayload.items;
            // If there is an ephemeral result, save it as well.
            const ephemeralResult = widget.data('transformer-ephemeral-result');
            if (ephemeralResult) {
                dataPayload.result = ephemeralResult;
            }
            // If there are prompt tokens, save them as well.
            const promptTokens = widget.data('transformer-ephemeral-source-size-tokens');
            if (promptTokens) {
                dataPayload.sources_size_tokens = promptTokens;
            }
            return dataPayload;
        }
    };
})();
